import styled, { css } from 'styled-components'

interface WebsiteLanguageSwitcherCurrentLangArrowUiStylesInterface {
  show: boolean
}
export const WebsiteLanguageSwitcherCurrentLangArrowUi = styled.div<WebsiteLanguageSwitcherCurrentLangArrowUiStylesInterface>`
  transition: transform 0.25 ease;

  ${p =>
    p.show &&
    css`
      transform: rotate(180deg);
    `}

`
